import { Link } from 'react-router-dom'
import { BsArrowLeftShort } from 'react-icons/bs'
import ProjectCard from "../Components/ProjectCard"

export default function Portfolio () {

    return (
        <div className="bg-gradient-to-bl from-gray-900 via-gray-800 to-gray-900" id="portfolio-container">
            <span className="place-self-start ml-3">
                    <Link to="/" className="inline-flex items-center px-4 py-2 mr-3 text-sm font-medium text-gray-400  rounded-lg hover:bg-green-500 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white" id="back-button">
                        <BsArrowLeftShort size={30}/>
                    </Link>
                </span>
            
            <ProjectCard />
    
        </div>
    )
}